// extracted by mini-css-extract-plugin
export var avatarContainer = "_ag-0";
export var avatarTypingWave = "_ag-i";
export var gray = "_ag-f";
export var green = "_ag-c";
export var icon = "_ag-9";
export var image = "_ag-1";
export var lg = "_ag-6";
export var md = "_ag-5";
export var presenceDot = "_ag-b";
export var red = "_ag-d";
export var sm = "_ag-4";
export var status = "_ag-a";
export var typingDot = "_ag-h";
export var typingPill = "_ag-g";
export var xl = "_ag-7";
export var xs = "_ag-3";
export var xxl = "_ag-8";
export var xxs = "_ag-2";
export var yellow = "_ag-e";